var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['quiz-result-item', { 'correct': _vm.result.isCorrect }, { 'incorrect': !_vm.result.isCorrect }]},[_c('span',{staticClass:"quiz-result-item__number"},[_vm._v(_vm._s(_vm.index + 1)+".")]),_c('span',{domProps:{"innerHTML":_vm._s(_vm.result.question)}}),_c('span',{class:_vm.result.isCorrect ?  'icon-checked' : 'icon-clear'})])
}
var staticRenderFns = []

export { render, staticRenderFns }